import { useState } from "react";
import type { AuthUser } from "../../types/inpact";
import { useAuthUser } from "../AuthGate";

interface UserPillProps {
  user: AuthUser | null;
}

export function UserPill({ user }: UserPillProps) {
  const [menuOpen, setMenuOpen] = useState(false);
  const { logout } = useAuthUser();
  if (!user) {
    return (
      <div className="user-pill" aria-label="Not signed in">
        <span className="user-pill__avatar">?</span>
        <span className="user-pill__email">signed out</span>
      </div>
    );
  }
  return (
    <div className="user-pill" role="group" aria-label={`Signed in as ${user.email}`}>
      <span className="user-pill__avatar" aria-hidden="true">{user.initials}</span>
      <span className="user-pill__email">{user.email}</span>
      <button
        type="button"
        className="user-pill__kebab"
        aria-label="User menu"
        aria-haspopup="menu"
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen((v) => !v)}
      >
        ⋮
      </button>
      {menuOpen && (
        <div className="user-pill__menu" role="menu">
          <button
            type="button"
            role="menuitem"
            className="user-pill__menu-item"
            onClick={() => {
              setMenuOpen(false);
              logout();
            }}
          >
            Sign out
          </button>
        </div>
      )}
    </div>
  );
}
